export const StickerPackType = {
	vendor: 'vendor',
	custom: 'custom',
};

export const StickerType = {
	image: 'image',
};
